import { Edit, ImageIcon, RefreshCw } from "lucide-react";
import { useState } from "react";
import { Button } from "../../../components/ui/button";
import Confirmation from "../../../components/Confirmation";
import { API, get } from "../../../config";
import { YodleeConnectModal } from "./YodleeConnectModal";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import { useMediaQuery } from "../../../components/use-media-query";

export default function IntegrationCard({
  logo,
  title,
  connected,
  fetchIntegration,
  type,
  trustId,
  setLoading,
  loading,
  oauth_url,
}) {
  const [hasError, setHasError] = useState(false);
  const [connectShow, setConnectShow] = useState(false);
  const [disconnectShow, setDisconnectShow] = useState(false);

  // Yodlee
  const config = {
    params: { configName: "" },
  };
  // eslint-disable-next-line no-unused-vars
  const [yodleeToken, setYodleeToken] = useState();
  const [openYodlee, setOpenYodlee] = useState(false);
  const [fastLinkData, setFastLinkData] = useState({});
  const isDesktop = useMediaQuery("(min-width: 768px)");
  // const [providerBankData, setProviderBankData] = useState(null);

  const toggleConnectShow = () => {
    setConnectShow(!connectShow);
  };

  const toggleDisconnectShow = () => {
    setDisconnectShow(!disconnectShow);
  };

  const handleConnect = async () => {
    if (type === "xero") {
      window.location.href = oauth_url;
      return;
    }
    try {
      setLoading(true);
      let { data } = await get(
        `${API.INTEGRATION_CONNECT}?trust_id=${trustId}&type=${type}`
      );
      if (type === "yodlee") {
        setYodleeToken(data?.data?.token);
        let accessToken = data?.data?.token?.accessToken;
        config.fastLinkURL = process.env.REACT_APP_YODLEE_FAST_LINK;
        config.accessToken = `Bearer ${accessToken}`;
        config.params.configName = process.env.REACT_APP_YODLEE_CONFIG_NAME;
        setOpenYodlee(true);
        setFastLinkData(config);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleDisconnect = async () => {
    try {
      setLoading(true);
      await get(
        `${API.INTEGRATION_DISCONNECT}?trust_id=${trustId}&type=${type}`
      );
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleYodleeEditControl = async (providerID) => {
    try {
      let config = {};
      setLoading(true);
      let { data } = await get(
        `${API.INTEGRATION_CONNECT}?trust_id=${trustId}&type=${type}`
      );
      let accessToken = data?.data?.token?.accessToken;
      config.fastLinkURL = process.env.REACT_APP_YODLEE_FAST_LINK;
      config.accessToken = `Bearer ${accessToken}`;
      config.params = {
        flow: "edit",
        providerAccountId: data?.provider_account_id,
        configName: process.env.REACT_APP_YODLEE_CONFIG_NAME,
        // obAppName: yodleeobAppName,
      };
      setLoading(false);
      setOpenYodlee(true);
      setFastLinkData(config);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleYodleeRefreshControl = async (providerID) => {
    try {
      let config = {};
      setLoading(true);
      let { data } = await get(
        `${API.INTEGRATION_CONNECT}?trust_id=${trustId}&type=${type}`
      );
      let accessToken = data?.data?.token?.accessToken;
      config.fastLinkURL = process.env.REACT_APP_YODLEE_FAST_LINK;
      config.accessToken = `Bearer ${accessToken}`;
      config.params = {
        flow: "refresh",
        providerAccountId: data?.provider_account_id,
        configName: process.env.REACT_APP_YODLEE_CONFIG_NAME,
      };
      setLoading(false);
      setOpenYodlee(true);
      setFastLinkData(config);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleYodleeModal = () => {
    setOpenYodlee(!openYodlee);
  };

  // const getProviderBankData = useCallback(async () => {
  //   try {
  //     setLoading(true);
  //     setProviderBankData(null);
  //     const { data } = await get(
  //       `${API.GET_PROVIDERS_BANK}?trust_id=${trustId}`
  //     );

  //     data?.data && data?.data?.length > 0
  //       ? data?.data?.forEach((element) => {
  //           setProviderBankData(element);
  //         })
  //       : setProviderBankData(null);
  //     setLoading(false);
  //   } catch (e) {
  //     setProviderBankData(null);
  //     setLoading(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [trustId]);

  // const handleProviderBank = () => {
  //   getProviderBankData();
  //   setDisconnectShow(false);
  // };

  return (
    <div className="relative w-full sm:w-[250px] text-center">
      {/* Shadow container */}
      <div className="rounded-2xl bg-muted shadow-2xl pt-12 pb-6 px-6 relative z-0">
        {/* Content inside card */}
        {/* <div className="text-md font-bold mb-4">{title}</div> */}

        <Button
          className={
            !connected ? "bg-webPrimary" : "bg-red-500 hover:bg-red-700"
          }
          onClick={() => {
            connected ? toggleDisconnectShow() : handleConnect();
          }}
        >
          {connected ? "DISCONNECT" : "CONNECT"}
        </Button>

        {window.fastlink.close()}
        {type === "yodlee" && connected && (
          <div className="flex justify-between px-2 -mt-6">
            <Edit
              onClick={() => handleYodleeEditControl()}
              className="w-5 h-5 cursor-pointer hover:text-webPrimary"
            />
            <RefreshCw
              onClick={() => handleYodleeRefreshControl()}
              className="w-5 h-5 cursor-pointer hover:text-webPrimary"
            />
          </div>
        )}
      </div>

      {/* Floating Logo (above, but inside flow) */}
      <div className="absolute -top-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-16 h-16 bg-white rounded-full shadow-lg flex items-center justify-center p-2">
          {hasError ? (
            <ImageIcon className="h-10 w-10 text-gray-400" />
          ) : (
            <img
              src={logo}
              alt={title}
              className="h-10"
              onError={() => setHasError(true)}
            />
          )}
        </div>
      </div>
      <Confirmation
        title={"Disconnect"}
        open={disconnectShow}
        setOpen={setDisconnectShow}
        toggleShow={() => {
          toggleDisconnectShow();
        }}
        className="sm:max-w-1/2"
        message={`Are you sure you want to disconnect ${type === "yodlee" ? "bank feeds" : type}?`}
        okAction={async () => {
          await handleDisconnect();
          toggleDisconnectShow();
          fetchIntegration && fetchIntegration();
        }}
        popupType={type}
        cancelAction={() => {
          toggleDisconnectShow();
        }}
        loading={loading}
      />
      <Confirmation
        title={"Connect"}
        open={connectShow}
        setOpen={setConnectShow}
        toggleShow={() => {
          toggleConnectShow();
        }}
        popupType={type}
        className="sm:max-w-1/2"
        message={`Are you sure you want to connect ${type === "yodlee" ? "bank feeds" : type}?`}
        okAction={async () => {
          handleConnect();
          toggleConnectShow();
          fetchIntegration && fetchIntegration();
        }}
        cancelAction={() => {
          toggleConnectShow();
        }}
        loading={loading}
      />
      {openYodlee && type === "yodlee" && (
        <ResponsiveDrawerForm
          description={""}
          title={"Yodlee Connect"}
          handleOpen={() => {}}
          handleClose={() => {
            setOpenYodlee(false);
          }}
          popupType={type}
          write={true}
          buttonText={""}
          className={isDesktop ? "w-1/2" : ""}
          open={openYodlee}
          buttonClassName={""}
          setOpen={setOpenYodlee}
        >
          <YodleeConnectModal
            fastLinkData={fastLinkData}
            trustId={trustId}
            handleYodleeModal={handleYodleeModal}
            fetchIntegration={fetchIntegration}
            setLoading={setLoading}
            openYodlee={openYodlee}
          />
        </ResponsiveDrawerForm>
      )}
    </div>
  );
}
